import tokenHttpClient from "../utils/httpClient";
import { post, postWithCSVResponse } from "../utils/httpClient-methods";
import {
  SPARE_API_URL,
  BASE_URL_SPARE_LIST,
  BASE_URL_SPARE,
  API_URL,
  BASE_URL,
} from "../utils/AppApiUrl";

export const SpareListingService = async (requestBody) => {
  try {
    const spareListingRequestObj = {
      spareSearchParam: {
        brandId: requestBody.spareSearchParam?.brandId,
        brickId: requestBody.spareSearchParam?.brickId,
        modelName: requestBody.spareSearchParam?.modelName,
        partTypeId: requestBody.spareSearchParam?.partTypeId,
        defActionId: requestBody.spareSearchParam?.defActionId,
        vendorId: requestBody.spareSearchParam?.vendorId,
        spareIds: requestBody.spareSearchParam?.spareIds,
        active: requestBody.spareSearchParam?.active,
        articleCode: requestBody.spareSearchParam?.articleCode,
        description:requestBody.spareSearchParam?.description,
      },
      sparePage: {
        pageNumber: requestBody.sparePage?.pageNumber,
        pageSize: requestBody.sparePage?.pageSize,
        sortDirection: requestBody.sparePage?.sortDirection,
        sortBy: requestBody.sparePage?.sortBy,
      },
    };
    const spareListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE_LIST}${SPARE_API_URL.spareListing}`,
      spareListingRequestObj
    );
    // add condition here to check
    if (spareListingResponse.status === 200) {
      return spareListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const SpareListingOnSearchService = async (requestBody) => {
  try {
    const spareListingRequestObj = {
      spareSearchParam: {
        brandId: requestBody?.brandId,
        brickId: requestBody?.brickId,
        modelName:
          requestBody && requestBody.modelName === ""
            ? null
            : requestBody.modelName,
        articleCode:
          requestBody && requestBody.articleCode === ""
            ? null
            : requestBody.articleCode,
        description:
          requestBody && requestBody.description === ""
            ? null
            : requestBody.description,
        active: requestBody?.active,
        partTypeId: requestBody?.partTypeId ?? null,
        defActionId: requestBody?.defActionId ?? null,
        vendorId: requestBody?.vendorId ?? null,
        spareIds: null,
      },
      sparePage: {
        pageNumber: requestBody?.pageNumber,
        pageSize: requestBody?.pageSize,
        sortDirection: requestBody?.sortDirection,
        sortBy: requestBody?.sortBy,
      },
    };
    const spareListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE_LIST}${SPARE_API_URL.spareListing}`,
      spareListingRequestObj
    );
    // add condition here to check
    if (spareListingResponse.status === 200) {
      return spareListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const StatusListingService = async () => {
  try {
    const statusListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.statusListing}`,
      null
    );
    // add condition here to check
    if (statusListingResponse.status === 200) {
      return statusListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const PartTypeListingService = async () => {
  try {
    const partTypeListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.partTypeListing}`,
      null
    );
    // add condition here to check
    if (partTypeListingResponse.status === 200) {
      return partTypeListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ActionsListingService = async () => {
  try {
    const actionsListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.actionListing}`,
      null
    );
    // add condition here to check
    if (actionsListingResponse.status === 200) {
      return actionsListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const spareStatusListingService = async () => {
  try {
    const spareStatusListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.spareStatusListing}`,
      null
    );
    // add condition here to check
    if (spareStatusListingResponse.status === 200) {
      return spareStatusListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const SpareChangeStatusService = async (requestBody) => {
  try {
    const userStatusResponse = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.updateSpareStatus}`,
      requestBody
    );
    // add condition here to check
    if (userStatusResponse.status === 200) {
      return userStatusResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onAddSpareService = async (data) => {
  try {
    const requestBody = {
      spareId: null,
      code: data.code,
      shortName: data.shortName ?? "",
      description: data.description ?? "",
      name: data.name ?? "",
      billingPR: parseInt(data.billingPR) ?? "",
      retailPR: parseInt(data.retailPR) ?? "",
      partTypeId: parseInt(data.partTypeId) ?? null,
      defSpareActionId: parseInt(data.defSpareActionId) ?? null,
      warranty: data.warranty,
      spec: data.spec ?? null,
      dimension: data.dimension ?? "",
      packInfo: data.packInfo ?? "",
      appInstall: data.appInstall ?? "",
      spCare: data.spCare ?? "",
      modifiedBy: data?.modifedBy ?? 0,
      modifiedOn: data?.modifiedOn ?? null,
      createdOn: data?.createdOn ?? new Date(),
      createdBy: data?.createdBy ?? 0,
      photoId: 1,
      active: true,
      vendorIds: data.vendorIds,
      supplierIds: data.supplierIds,
      createdByName: data.createdByName,
      modifiedByName: "1",
      statusId: 1,
      shortDesc: data.shortDesc ?? null,
      supplierAcode: data.supplierAcode ? data.supplierAcode.trim() : "",
      sendNotification: data.sendNotification,
      spareStatus: data.spareStatus ? data.spareStatus : "",
    };
    const saveSpareDetails = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.saveSpareDetails}`,
      requestBody
    );
    if (saveSpareDetails.status === 200 || saveSpareDetails.status === 201) {
      return saveSpareDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onEditSpareService = async (data) => {
  try {
    const requestBody = {
      spareId: data.spareId,
      code: data.code,
      shortName: data.shortName ?? "",
      description: data.description ?? "",
      name: data.name ?? "",
      billingPR: data.billingPR ?? "",
      retailPR: data.retailPR ?? "",
      partTypeId: parseInt(data.partTypeId) ?? null,
      defSpareActionId: parseInt(data.defSpareActionId) ?? null,
      warranty: data.warranty,
      spec: data.spec ?? null,
      dimension: data.dimension ?? "",
      packInfo: data.packInfo ?? "",
      appInstall: data.appInstall ?? "",
      spCare: data.spCare ?? "",
      modifiedBy: data?.modifiedBy ?? 0,
      modifiedOn: new Date(),
      createdOn: data?.createdOn,
      createdBy: data?.createdBy ?? 1,
      photoId: 1,
      active: data && data.active === "false" ? false : true,
      vendorIds: data.vendorIds,
      supplierIds: data.supplierIds,
      statusId: 1,
      modifiedByName: data.modifiedByName,
      createdByName: data.createdByName,
      shortDesc: data.shortDesc ?? null,
      sendNotification: data.sendNotification,
      supplierAcode: data.supplierAcode ? data.supplierAcode.trim() : "",
      spareStatus: data.spareStatus ? data.spareStatus : "",
    };
    const editSpareDetails = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.updateSpareDetails}`,
      requestBody
    );
    if (editSpareDetails.status === 200 || editSpareDetails.status === 201) {
      return editSpareDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const fetchSpareDetailsByIdService = async (id) => {
  try {
    const param = {
      spareId: id,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE_LIST}${SPARE_API_URL.fetchSpareDetailsById}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const SpareListingBySpareIdService = async (requestBody) => {
  try {
    const modelRequestObj = {
      altSpareSearchParam: {
        spareId: requestBody?.spareId,
        brandId: requestBody?.brandId,
        brickId: requestBody?.brickId,
        status: requestBody?.status,
        partTypeId: requestBody?.partTypeId,
        modelName:
          requestBody && requestBody.modelName === ""
            ? null
            : requestBody.modelName,
      },
      sparePage: {
        pageNumber: requestBody?.pageNumber,
        pageSize: requestBody?.pageSize,
        sortDirection: requestBody?.sortDirection,
        sortBy: requestBody?.sortBy,
      },
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE_LIST}${SPARE_API_URL.getAlternateSpareBySpareId}`,
      modelRequestObj
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const SpareListingBySpareIdOnSearchService = async (requestBody) => {
  try {
    const modelRequestObj = {
      altSpareSearchParam: {
        spareId: requestBody?.spareId,
        brandId: requestBody?.brandId,
        brickId: requestBody?.brickId,
        status: requestBody?.status,
        partTypeId: requestBody?.partTypeId,
        modelName:
          requestBody && requestBody.modelName === ""
            ? null
            : requestBody.modelName,
      },
      sparePage: {
        pageNumber: requestBody?.pageNumber,
        pageSize: requestBody?.pageSize,
        sortDirection: requestBody?.sortDirection,
        sortBy: requestBody?.sortBy,
      },
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE_LIST}${SPARE_API_URL.getAlternateSpareBySpareId}`,
      modelRequestObj
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const LinkAlternateSpareWithSpareService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.linkAlternateSpare}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadSparesService = async (requestBody) => {
  try {
    const param = {
      brandId: requestBody.brandId,
      brickId: requestBody.brickId,
      modelName: requestBody.modelName,
      active: requestBody.active ?? 2,
      spareIds: requestBody.spareIds,
      vendorId: requestBody.vendorId,
      defActionId: requestBody.defActionId,
      articleCode: requestBody.articleCode?requestBody.articleCode : null,
      description: requestBody.description?requestBody.description : null,
      partTypeId: requestBody.partTypeId,
    };
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.downloadSpareDetails}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const VendorListingService = async (type) => {
  try {
    const param = {
      type: type ? type : "VENDORS",
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${API_URL.vendorDetailsInAddSpare}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ModelListingBySpareIdService = async (spareId) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE_LIST}${SPARE_API_URL.getModelBySpare}`,
      spareId
    );
    // add condition here to checkget
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const VendorListingBySpareIdService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE_LIST}${SPARE_API_URL.getVendorBySpare}`,
      requestBody
    );
    // add condition here to checkget
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadModelsBySpareIdService = async (id) => {
  try {
    const param = {
      spareId: parseInt(id),
    };
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadModelsBySpareId}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};


export const deleteSpareService = async (id) => {
  try {
    const param = {
      spareId: parseInt(id),
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.deleteSpare}`,
      id
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
}